// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#notFound h1.signatureFont {
  font-size: 10rem; }

@media screen and (max-width: 600px) {
  #notFound h1.signatureFont {
    font-size: 5rem; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdAboutUs {
  min-height: 500px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; }
  #sdAboutUs .card {
    border-radius: 0; }
    #sdAboutUs .card .card-body p {
      line-height: 2;
      font-size: 14px !important; }
      #sdAboutUs .card .card-body p::first-letter {
        line-height: 2;
        font-size: 65px;
        float: left;
        padding-right: 10px; }

#sdMission p {
  line-height: 24px;
  font-size: 14px !important;
  letter-spacing: 1px; }

#sdFeatures {
  background-color: #000; }
  #sdFeatures h2, #sdFeatures h5, #sdFeatures p {
    color: #fff; }
  #sdFeatures .col-md-3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid #464646;
    position: relative;
    overflow: hidden; }
    #sdFeatures .col-md-3 img {
      width: 30%;
      margin: 20px 0 20px 20px;
      filter: invert(1); }
    #sdFeatures .col-md-3 p {
      padding: 20px;
      position: absolute;
      height: 100%;
      width: 100%;
      background-color: #000000cc;
      transition: all 1s;
      top: 100%;
      vertical-align: middle; }
    #sdFeatures .col-md-3:hover p {
      top: 0; }
    @media (max-width: 768px) {
      #sdFeatures .col-md-3 img {
        width: 80%;
        margin: 10px 0; }
      #sdFeatures .col-md-3 h5 {
        font-size: 16px; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdCartArea {
  z-index: 999999; }
  #sdCartArea #sdBackground {
    display: none;
    position: fixed;
    height: 100vh;
    width: 99.9vw;
    background-color: #000000aa;
    top: 0; }
  #sdCartArea lottie-player {
    height: 200px;
    width: 200px; }
  #sdCartArea #sdCart {
    position: fixed;
    top: 0px;
    width: 400px;
    height: 100vh;
    background-color: whitesmoke;
    right: 0px;
    box-shadow: rgba(99, 99, 99, 0.2) 0 2px 8px 0;
    transform: translateX(100%);
    transition: transform 0.5s;
    z-index: 9999999;
    max-width: 99.99vw; }
    #sdCartArea #sdCart #nonEmptyCart {
      display: flex; }
      #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
        font-size: 14px;
        font-weight: 700; }
    #sdCartArea #sdCart #emptyCart {
      display: none; }
    #sdCartArea #sdCart.empty #nonEmptyCart {
      display: none; }
    #sdCartArea #sdCart.empty #emptyCart {
      display: flex; }
    #sdCartArea #sdCart.empty.updating {
      display: none; }
    #sdCartArea #sdCart.updating #emptyCart {
      display: none !important; }
    #sdCartArea #sdCart #sdCartItemArea {
      overflow-y: auto;
      flex-grow: 1; }
      #sdCartArea #sdCart #sdCartItemArea .cartItem {
        margin-bottom: 10px;
        padding: 10px 0;
        text-decoration: none;
        color: #000; }
        #sdCartArea #sdCart #sdCartItemArea .cartItem:hover {
          background-color: lightgray; }
        #sdCartArea #sdCart #sdCartItemArea .cartItem .col-9 h6::nth-of-type(1) {
          color: gray;
          font-weight: 200;
          font-size: 12px; }
        #sdCartArea #sdCart #sdCartItemArea .cartItem .col-9 h6::nth-of-type(2) {
          font-weight: 200;
          font-size: 14px; }
    #sdCartArea #sdCart #sdDetailsBox {
      background-color: #fff;
      margin: 20px;
      padding: 30px 30px 0 30px; }
      #sdCartArea #sdCart #sdDetailsBox div p {
        font-size: 12px;
        margin-bottom: 8px; }
      #sdCartArea #sdCart #sdDetailsBox div > p:nth-of-type(2) {
        font-weight: 600; }
      #sdCartArea #sdCart #sdDetailsBox div:nth-of-type(3) p {
        font-size: 16px;
        font-style: normal; }
      #sdCartArea #sdCart #sdDetailsBox > p {
        font-size: 12px; }
  #sdCartArea #loader {
    display: none;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: #000000aa;
    top: 0;
    z-index: 9999999; }
    #sdCartArea #loader lottie-player {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%); }
    #sdCartArea #loader.show {
      display: block; }
  @media screen and (max-width: 420px) {
    #sdCartArea #sdCart {
      width: 100% !important; } }

#sdCartArea.show #sdBackground {
  display: block; }

#sdCartArea.show #sdCart {
  transform: translateX(0) !important; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdCarousel {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  overflow: hidden;
  position: relative;
  aspect-ratio: 16/9;
  background-color: #dbdbdb;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover; }
  @media (max-width: 870px) {
    #sdCarousel {
      aspect-ratio: 1/1; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

.collectionTheIndianAffair p::first-letter {
  line-height: 2;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

.sdCategoryHeader {
  background-color: #f6cfd9; }
  .sdCategoryHeader p {
    letter-spacing: 1px;
    line-height: 24px; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

.modal .modal-content {
  border-radius: 0; }

.modal .modal-body {
  border-radius: 0;
  padding: 0; }

.modal h5 {
  font-size: 21px !important;
  margin-bottom: 30px !important; }

.modal p {
  font-family: "Raleway", sans-serif !important;
  font-size: 14px !important;
  font-weight: 300 !important; }

.modal input {
  border: solid 2px #000 !important;
  border-radius: 0 !important;
  font-size: 12px !important;
  border-width: 0 0 2px 0 !important; }

.modal input ::placeholder {
  font-family: "Raleway", sans-serif !important; }

.modal #sdSideImage {
  width: 100%;
  aspect-ratio: 1/1;
  background-image: url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/SD05-Bralette-Back.jpg?v=1764647409");
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center; }

.modal #sdSideImage div {
  width: 90%;
  aspect-ratio: 1/1;
  border: #000 2px solid;
  display: flex;
  justify-content: center;
  align-items: center; }

.modal #sdSideImage img {
  max-height: 90%;
  filter: invert(1); }

.modal .fields {
  margin-bottom: 10px;
  width: 100%; }

.modal .fields .validation {
  color: red;
  font-size: 12px;
  display: none; }

.modal .fields.is-invalid .validation {
  margin-bottom: 0px;
  line-height: 30px !important;
  display: block; }

.socialMedia {
  display: flex;
  justify-content: center; }
  .socialMedia a {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: solid 2px #000;
    margin: 0 10px 10px 10px;
    line-height: 48px;
    text-align: center;
    font-size: 25px;
    color: #000; }
    .socialMedia a:hover {
      background-color: #000;
      color: #fff; }

#gateway_password input {
  background-color: transparent !important;
  color: #fff !important;
  border-color: #fff !important; }

#gateway_password .modal button {
  background-color: #fff !important;
  color: #000 !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 10px 20px !important;
  font-size: 14px !important; }
  #gateway_password .modal button:disabled {
    background-color: gray !important;
    color: #000 !important; }

#gateway_password .socialMedia a {
  border-color: #fff;
  color: #fff; }
  #gateway_password .socialMedia a:hover {
    background-color: #fff;
    color: #000; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdPageContent {
  margin-top: 150px; }

.sdFixedHeader #sdPageContent {
  margin-top: 90px; }

body.landing #backgroundOverlay {
  background-color: rgba(255, 255, 255, 0.8) !important;
  clip-path: polygon(5% 5%, 95% 7%, 95% 95%, 5% 95%); }

body.landing #sdPageContent {
  margin-top: 0 !important; }

#sdStdHeader {
  height: 150px;
  width: 99.99vw;
  position: fixed;
  top: 0px;
  z-index: 999;
  transition: all 1s ease; }
  #sdStdHeader #backgroundOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f6cfd9;
    z-index: -1; }
  #sdStdHeader .sdLogo, #sdStdHeader .sdLogoCollapsed, #sdStdHeader .sdTopLeftMenu.sdBottomCenterLeftMenu, #sdStdHeader .sdBottomCenterRightMenu, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a {
    transition: all 1s; }
  #sdStdHeader .sdLogo {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 80%;
    top: 50%; }
  #sdStdHeader .sdLogoCollapsed {
    position: absolute;
    left: 50%;
    transform: translateX(-50%) scale(0.001);
    height: 100%;
    opacity: 0; }
  #sdStdHeader .sdTopLeftMenu {
    position: absolute;
    top: 0;
    left: 20px;
    padding: 10px; }
    #sdStdHeader .sdTopLeftMenu a {
      text-decoration: none;
      color: #000;
      margin-right: 20px;
      font-size: 12px; }
      #sdStdHeader .sdTopLeftMenu a:hover {
        text-decoration: underline; }
  #sdStdHeader #sdMenuArea {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
    transition: all 1s; }
    #sdStdHeader #sdMenuArea #sdSidebarToggleSwitch {
      display: none; }
  #sdStdHeader .sdBottomCenterLeftMenu, #sdStdHeader .sdBottomCenterRightMenu {
    top: 103px; }
    #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a {
      text-decoration: none;
      color: #000;
      margin-right: 20px;
      font-size: 14px;
      text-transform: uppercase;
      text-decoration: none !important;
      position: relative; }
      #sdStdHeader .sdBottomCenterLeftMenu a span:after, #sdStdHeader .sdBottomCenterRightMenu a span:after {
        background: none repeat scroll 0 0 transparent;
        bottom: -10px;
        content: "";
        display: block;
        height: 2px;
        left: 50%;
        position: absolute;
        background: #000;
        transition: width 0.3s ease 0s, left 0.3s ease 0s;
        width: 0; }
      #sdStdHeader .sdBottomCenterLeftMenu a span:hover:after, #sdStdHeader .sdBottomCenterRightMenu a span:hover:after {
        width: 100%;
        left: 0; }
  #sdStdHeader .sdBottomCenterLeftMenu {
    margin-right: 20px; }
    #sdStdHeader .sdBottomCenterLeftMenu a {
      margin: 0 0 0 20px; }
  #sdStdHeader .sdBottomCenterRightMenu {
    margin-left: 20px; }
    #sdStdHeader .sdBottomCenterRightMenu a {
      margin: 0 20px 0 0; }
  @media (max-width: 1335px) {
    #sdStdHeader .sdBottomCenterLeftMenu, #sdStdHeader .sdBottomCenterRightMenu {
      position: relative; }
      #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a {
        margin: 10px 20px; } }
  #sdStdHeader .sdBottomCenterLeftMenu {
    position: absolute;
    right: 50%;
    transform: translateX(-100px); }
    #sdStdHeader .sdBottomCenterLeftMenu a {
      text-align: right; }
  #sdStdHeader .sdBottomCenterRightMenu {
    position: absolute;
    left: 50%;
    transform: translateX(100px); }
    #sdStdHeader .sdBottomCenterRightMenu li {
      display: inline-block; }
  @media (max-width: 1060px) {
    #sdStdHeader .sdBottomCenterLeftMenu, #sdStdHeader .sdBottomCenterRightMenu {
      display: none; }
    #sdStdHeader .sdLogo, #sdStdHeader .sdLogoM {
      display: none; }
    #sdStdHeader .sdLogoCollapsed {
      left: 30px;
      transform: translateX(0); }
    #sdStdHeader .sdLogoM {
      display: block;
      position: absolute;
      height: 120%;
      left: 30px; }
    #sdStdHeader .sdTopLeftMenu {
      position: absolute;
      top: 0;
      right: 20px !important;
      padding: 10px;
      display: flex;
      justify-content: end; }
    #sdStdHeader #sdMenuArea #sdSidebarToggleSwitch {
      display: initial; } }
  #sdStdHeader .sdMenu ul {
    margin-left: 0; }
    #sdStdHeader .sdMenu ul li {
      font-size: 12px;
      text-transform: uppercase;
      margin: 10px 0;
      list-style-type: none; }
      #sdStdHeader .sdMenu ul li a {
        color: #000;
        text-decoration: none !important; }

@media (max-width: 550px) {
  #sdStdHeader {
    height: 150px; }
    #sdStdHeader .sdTopLeftMenu {
      display: none; } }

@media (max-width: 470px) {
  #sdStdHeader .sdLogoCollapsed {
    height: 40px; } }

body.showSideBar {
  overflow-y: hidden; }
  body.showSideBar #sdStdSideBar {
    transform: translateX(0) !important; }

.StdHeaderCollapsedClass, .sdFixedHeader #sdStdHeader, #sdStdHeader.sdCollapsed {
  height: 90px; }
  .StdHeaderCollapsedClass #backgroundOverlay, .sdFixedHeader #sdStdHeader #backgroundOverlay, #sdStdHeader.sdCollapsed #backgroundOverlay {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%); }
  .StdHeaderCollapsedClass .sdTopLeftMenu, .sdFixedHeader #sdStdHeader .sdTopLeftMenu, #sdStdHeader.sdCollapsed .sdTopLeftMenu {
    opacity: 0; }
  .StdHeaderCollapsedClass .sdLogo, .sdFixedHeader #sdStdHeader .sdLogo, #sdStdHeader.sdCollapsed .sdLogo {
    opacity: 0; }
  .StdHeaderCollapsedClass .sdLogoCollapsed, .sdFixedHeader #sdStdHeader .sdLogoCollapsed, #sdStdHeader.sdCollapsed .sdLogoCollapsed {
    opacity: 1;
    transform: translateX(-50%) scale(1); }
  .StdHeaderCollapsedClass .sdBottomCenterLeftMenu, .sdFixedHeader #sdStdHeader .sdBottomCenterLeftMenu, #sdStdHeader.sdCollapsed .sdBottomCenterLeftMenu, .StdHeaderCollapsedClass .sdBottomCenterRightMenu, .sdFixedHeader #sdStdHeader .sdBottomCenterRightMenu, #sdStdHeader.sdCollapsed .sdBottomCenterRightMenu {
    right: unset;
    left: unset;
    transform: unset;
    transition: all 1s; }
    .StdHeaderCollapsedClass .sdBottomCenterLeftMenu a, .sdFixedHeader #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader.sdCollapsed .sdBottomCenterLeftMenu a, .StdHeaderCollapsedClass .sdBottomCenterRightMenu a, .sdFixedHeader #sdStdHeader .sdBottomCenterRightMenu a, #sdStdHeader.sdCollapsed .sdBottomCenterRightMenu a {
      font-size: 14px;
      transition: all 1s; }
  .StdHeaderCollapsedClass .sdBottomCenterRightMenu, .sdFixedHeader #sdStdHeader .sdBottomCenterRightMenu, #sdStdHeader.sdCollapsed .sdBottomCenterRightMenu {
    left: 60%;
    top: 35px; }
    .StdHeaderCollapsedClass .sdBottomCenterRightMenu a, .sdFixedHeader #sdStdHeader .sdBottomCenterRightMenu a, #sdStdHeader.sdCollapsed .sdBottomCenterRightMenu a {
      margin: 0 0 0 10px !important; }
  .StdHeaderCollapsedClass .sdBottomCenterLeftMenu, .sdFixedHeader #sdStdHeader .sdBottomCenterLeftMenu, #sdStdHeader.sdCollapsed .sdBottomCenterLeftMenu {
    right: 60%;
    top: 35px; }
    .StdHeaderCollapsedClass .sdBottomCenterLeftMenu a, .sdFixedHeader #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader.sdCollapsed .sdBottomCenterLeftMenu a {
      margin: 0 10px 0 0 !important; }

#sdStdHeaderSM {
  height: 90px;
  width: 99.99vw;
  background-color: #f6cfd9;
  position: fixed;
  top: 0px;
  z-index: 9999;
  transition: all 1s ease;
  display: none; }
  #sdStdHeaderSM #sdMenuArea {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    transition: all 1s; }
    #sdStdHeaderSM #sdMenuArea #sdSidebarToggleSwitch {
      display: none; }
  #sdStdHeaderSM .sdLogoCollapsed {
    margin-left: 20px; }
  #sdStdHeaderSM #sdStdSideBar {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    z-index: 999;
    background-color: #202020;
    transition: transform 0.3s ease-in-out;
    transform: translateX(-100%);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center; }
    #sdStdHeaderSM #sdStdSideBar #close {
      cursor: pointer;
      font-size: 24px;
      display: flex;
      justify-content: end;
      width: 100%; }
      #sdStdHeaderSM #sdStdSideBar #close button {
        background-color: #fff;
        color: #000;
        align-self: flex-end; }
    #sdStdHeaderSM #sdStdSideBar #sdLogoText {
      width: 80%;
      margin: 30px auto;
      filter: invert(1); }
    #sdStdHeaderSM #sdStdSideBar #sdLogo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      z-index: -1;
      opacity: 0.2; }
    #sdStdHeaderSM #sdStdSideBar #diamond {
      background-color: #fff;
      width: 50%;
      height: 10px;
      transform: skew(-45deg);
      margin-bottom: 30px; }
    #sdStdHeaderSM #sdStdSideBar #menuArea {
      overflow-y: scroll;
      width: 100%; }
      #sdStdHeaderSM #sdStdSideBar #menuArea .menus {
        margin-bottom: 30px;
        width: 100%; }
        #sdStdHeaderSM #sdStdSideBar #menuArea .menus a {
          text-decoration: none;
          color: #fff;
          font-size: 12px;
          border: #ffffff6e solid 1px;
          border-width: 0.5px 0;
          display: block;
          padding: 10px 20px;
          font-weight: 300 !important; }
          #sdStdHeaderSM #sdStdSideBar #menuArea .menus a:hover {
            text-decoration: underline; }
      #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright {
        color: #fff;
        font-size: 10px;
        text-align: center;
        padding: 5px 10px; }
  @media (max-width: 1060px) {
    #sdStdHeaderSM .sdLogoCollapsed {
      left: 30px;
      transform: translateX(0); }
    #sdStdHeaderSM #sdMenuArea #sdSidebarToggleSwitch {
      display: initial; } }

@media (max-width: 400px) {
  #sdStdHeaderSM .sdLogoCollapsed {
    height: 70px; } }

@media (max-width: 1060px) {
  #sdStdHeader {
    display: none; }
  #sdStdHeaderSM {
    display: flex;
    align-items: center; }
  #sdPageContent {
    margin-top: 90px; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdLoader {
  position: fixed;
  top: 0;
  left: 0;
  width: 99.99vw;
  height: 100vh;
  background: #fff;
  transition: opacity 1s ease-in-out;
  z-index: 9999999999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }
  #sdLoader.sdHideLoader {
    opacity: 0; }
  #sdLoader #sdLogoContainer {
    max-height: 70vh;
    height: 300px; }
  #sdLoader #sdLoaderMessage {
    font-family: 'Didor', serif;
    font-size: 18px;
    font-weight: 300;
    margin-top: 20px;
    text-align: center; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdProduct #sdBreadcrumbs {
  font-size: 12px; }
  #sdProduct #sdBreadcrumbs a {
    text-decoration: none;
    color: grey !important; }

#sdProduct #sdProductViewer {
  position: sticky;
  top: 90px; }

#sdProduct #sdViewer img {
  width: 100%; }

#sdProduct .sdDescription {
  font-size: 16px;
  text-transform: none !important;
  line-height: 24px;
  letter-spacing: 1px; }

#sdProduct h6 {
  font-size: 12px !important;
  margin-top: 30px; }

#sdProduct .sdVariant {
  height: 30px;
  aspect-ratio: 1/1;
  border: 1px gray solid;
  margin: 5px;
  line-height: 30px;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center; }
  #sdProduct .sdVariant .sdColorSwatch {
    height: 80%;
    aspect-ratio: 1/1;
    border: 0.5px solid #efefef; }
  #sdProduct .sdVariant p {
    padding: 0 5px;
    line-height: 30px;
    vertical-align: middle;
    margin: 0;
    font-size: 12px;
    font-weight: 200; }
  #sdProduct .sdVariant.selected {
    opacity: 1;
    border: 2px #000 solid; }
  #sdProduct .sdVariant.unavailable {
    cursor: not-allowed;
    filter: blur(1px) saturate(0); }

#sdProduct #sdAccordion .accordion-item {
  border-width: 0; }
  #sdProduct #sdAccordion .accordion-item .accordion-button {
    background-color: transparent !important;
    border-width: 0; }

#sdProduct #sdSizeChart {
  font-size: 12px;
  border-width: 0;
  display: inline-block; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdProductCategories .col-6 {
  z-index: 99 !important; }

#sdProductCategories .sdProductCategory {
  position: relative;
  cursor: pointer;
  overflow: hidden; }
  #sdProductCategories .sdProductCategory h2 {
    position: absolute;
    color: #fff;
    z-index: 9;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%); }
  #sdProductCategories .sdProductCategory img {
    transform: scale(1); }
    #sdProductCategories .sdProductCategory img:hover {
      transform: scale(1.1); }
  #sdProductCategories .sdProductCategory div {
    width: 100%;
    height: 100%;
    position: absolute;
    background: linear-gradient(180deg, rgba(0, 63, 91, 0) 52%, black 100%);
    top: 0;
    transition: all 1s; }
    #sdProductCategories .sdProductCategory div:hover {
      background: linear-gradient(180deg, rgba(0, 63, 91, 0) 25%, black 100%); }

@media (max-width: 870px) {
  #sdProductCategories {
    grid-template-columns: repeat(2, 1fr); }
    #sdProductCategories .sdCategory {
      aspect-ratio: 1/1 !important; }
    #sdProductCategories h5 {
      bottom: initial !important;
      top: 50%; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

.sdProductShowcase h6 {
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  color: #000 !important;
  text-decoration: none !important;
  text-decoration-color: transparent; }

.sdProductShowcase h4, .sdProductShowcase h5 {
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #000 !important; }

@media (max-width: 574px) {
  .sdProductShowcase h3 {
    font-size: 16px; }
  .sdProductShowcase h4 {
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 1px; }
  .sdProductShowcase h6 {
    font-size: 12px; } }

.sdProductShowcase .col-md-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none; }
  .sdProductShowcase .col-md-3 .sdProductImg {
    width: 100%;
    aspect-ratio: 1/1;
    display: flex;
    position: relative;
    margin: 10px;
    justify-content: center;
    align-items: center;
    overflow: hidden; }
    .sdProductShowcase .col-md-3 .sdProductImg .sdLogoContainer {
      position: absolute;
      width: 100%;
      transition: opacity 3s ease-in-out; }
    .sdProductShowcase .col-md-3 .sdProductImg .sdFeaturedImage {
      position: absolute;
      width: 100%;
      height: auto;
      top: 0;
      transition: all 1s ease-in-out; }
      .sdProductShowcase .col-md-3 .sdProductImg .sdFeaturedImage:hover {
        opacity: 0; }
    .sdProductShowcase .col-md-3 .sdProductImg .sdHoverImage {
      opacity: 1;
      transition: opacity 1s ease-in-out,transform 6s ease-in-out; }
  .sdProductShowcase .col-md-3:hover .sdHoverImage {
    opacity: 1; }
  .sdProductShowcase .col-md-3:hover .sdFeaturedImage :not(.sdOnlyOne) {
    opacity: 0; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdFooter {
  background-color: #f6cfd9; }
  #sdFooter #sdLogoFooter {
    width: 50%;
    height: auto;
    display: block;
    margin: 0 auto; }
  #sdFooter .menuLinks {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    font-size: 13px;
    text-transform: uppercase; }
    #sdFooter .menuLinks h6 {
      font-size: 18px;
      margin-bottom: 30px; }
    #sdFooter .menuLinks a {
      text-decoration: none;
      color: #000;
      margin-bottom: 20px; }
  #sdFooter #sdMailingList {
    display: flex; }
    #sdFooter #sdMailingList input {
      height: 43px;
      background: #f6cfd9;
      border-width: 0 0 0.8px 0;
      font-size: 12px; }
    #sdFooter #sdMailingList button {
      border-width: 0 0 2px 0;
      text-transform: uppercase; }
  #sdFooter #sdGotsCertification {
    height: 100px;
    position: relative;
    display: block; }
    #sdFooter #sdGotsCertification img {
      position: absolute;
      transition: all 1s;
      height: 100%; }
    #sdFooter #sdGotsCertification img:nth-of-type(1) {
      opacity: 0; }
    #sdFooter #sdGotsCertification img:nth-of-type(2) {
      filter: invert(1); }
    #sdFooter #sdGotsCertification:hover img:nth-of-type(1) {
      opacity: 1; }
    #sdFooter #sdGotsCertification:hover img:nth-of-type(2) {
      opacity: 0; }

#sdSubFooter {
  background-color: #000;
  height: 80px; }
  #sdSubFooter .row, #sdSubFooter .container {
    height: 100%;
    justify-content: center; }
  #sdSubFooter .col-12 {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center; }
    #sdSubFooter .col-12 .sdSocialMediaIcon {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      border: solid 2px #fff;
      margin: 0 10px;
      line-height: 46px;
      text-align: center; }
      #sdSubFooter .col-12 .sdSocialMediaIcon i {
        color: #fff;
        font-size: 20px; }
      #sdSubFooter .col-12 .sdSocialMediaIcon:hover {
        background-color: #f6cfd9;
        color: #000 !important;
        transition: all 0.3s ease-in-out; }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdSustainabilityBanner #banner {
  background-color: azure;
  width: 100%;
  display: flex;
  margin: 30px 0;
  position: relative;
  overflow: hidden; }
  #sdSustainabilityBanner #banner #bannerImage {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/sustainable.jpg?v=1755535077");
    background-size: cover;
    background-position: center;
    filter: blur(3px); }
  #sdSustainabilityBanner #banner #box {
    background-color: #fff;
    width: 35%;
    border: 2px solid #000;
    outline: 20px solid #fff;
    margin: 70px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;
    z-index: 9; }
    #sdSustainabilityBanner #banner #box h2 {
      font-family: 'Times New Roman', Times, serif;
      text-align: left;
      font-size: 50px; }
    #sdSustainabilityBanner #banner #box p {
      font-size: 16px;
      text-align: left;
      line-height: 35px;
      letter-spacing: 1px; }
  @media screen and (max-width: 1180px) {
    #sdSustainabilityBanner #banner #box {
      width: 50%; } }
  @media screen and (max-width: 991px) {
    #sdSustainabilityBanner #banner {
      justify-content: center; }
      #sdSustainabilityBanner #banner #box {
        width: 90%; }
        #sdSustainabilityBanner #banner #box h2 {
          font-size: 30px; }
        #sdSustainabilityBanner #banner #box p {
          font-size: 14px; } }
  @media screen and (max-width: 420px) {
    #sdSustainabilityBanner #banner {
      margin: 10px; }
      #sdSustainabilityBanner #banner #box {
        width: 100%; }
        #sdSustainabilityBanner #banner #box h2 {
          font-size: 30px; }
        #sdSustainabilityBanner #banner #box p {
          font-size: 12px;
          line-height: 16px; } }

@font-face {
  font-family: 'Roboto';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677"); }

@font-face {
  font-family: 'Signature';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739"); }

@font-face {
  font-family: 'Didor';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960"); }

@font-face {
  font-family: 'Montserrat';
  src: local, url("https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059"); }

*:disabled {
  cursor: not-allowed; }

.primaryFont, .capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter, h2, h1, h3, #sdAboutUs .card .card-body p::first-letter, .collectionTheIndianAffair p::first-letter, #sdStdHeader .sdTopLeftMenu a, #sdStdHeaderSM #sdStdSideBar #menuArea .menus a, #sdStdHeaderSM #sdStdSideBar #menuArea .sdCopyright, #sdProduct #sdBreadcrumbs, #sdProduct .sdDescription, #sdProduct .sdVariant, #sdProductCategories .sdProductCategory h2, .sdProductShowcase h6, #sdFooter #sdMailingList input {
  font-family: "Old Standard TT", serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-style: normal; }

.signatureFont {
  font-family: "Signature", serif; }

.heroFont, #sdCartArea #sdCart #nonEmptyCart h3 .warningMessage {
  font-family: "Didor", serif; }

.secondaryFont, p, li, #sdAboutUs .card .card-body p, .modal input, #sdStdHeader .sdBottomCenterLeftMenu a, #sdStdHeader .sdBottomCenterRightMenu a, .sdProductShowcase h4, .sdProductShowcase h5, #sdFooter .menuLinks, #sdSustainabilityBanner #banner #box p {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 12px;
  line-height: 1.5; }

button, a.button {
  font-family: "Old Standard TT", serif;
  font-weight: 300;
  border: 2px solid #000;
  background-color: transparent;
  padding: 12px 25px;
  text-transform: uppercase !important;
  color: #000 !important;
  text-decoration: none;
  letter-spacing: 2px;
  text-align: center;
  font-size: 12px;
  line-height: 12px; }
  button.noBorder, a.button.noBorder {
    border-color: transparent;
    padding: 10px 10px; }
  button:hover, a.button:hover {
    background-color: #000;
    color: #fff !important;
    transition: all 1s ease-in-out; }
  button.dark, a.button.dark {
    color: #fff !important;
    background-color: #000; }
  button.light, a.button.light {
    background-color: #fff;
    color: #000 !important;
    border-color: #000;
    outline: #fff solid 5px; }
  button:disabled, a.button:disabled {
    opacity: 0.4; }
    button:disabled:hover, a.button:disabled:hover {
      background-color: transparent;
      border: 2px solid #000;
      color: #000 !important; }

.capitaliseFirstLetter::first-letter, .capitaliseFirstLetter p::first-letter {
  line-height: 65px;
  font-size: 65px;
  float: left;
  padding-right: 10px; }

h2 {
  text-transform: none; }

p {
  line-height: 2; }

h1 {
  padding-top: 30px !important; }

.sdBlogCard {
  color: #fff;
  text-decoration: none;
  height: 400px !important;
  background-size: cover;
  border-radius: 0 !important; }
  .sdBlogCard:hover .card-body h2 {
    color: black;
    background-color: #fff; }
  .sdBlogCard .card-body {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    justify-content: end; }
    .sdBlogCard .card-body h4 {
      background-color: pink;
      padding: 5px 10px;
      color: black; }
    .sdBlogCard .card-body h2 {
      background-color: black;
      color: white;
      padding: 5px 10px;
      font-size: 25px;
      transition: all 0.5s ease-in-out; }

#sdToast #liveToast {
  background-color: #000;
  border-radius: 0;
  border-left: 8px solid #f6cfd9; }
  #sdToast #liveToast h5, #sdToast #liveToast p {
    color: #fff !important; }
`, "",{"version":3,"sources":["webpack://./src/style/variables.scss","webpack://./src/style/404.scss","webpack://./src/style/aboutUs.scss","webpack://./src/style/cart.scss","webpack://./src/style/carousel.scss","webpack://./src/style/collection.scss","webpack://./src/style/gateway.scss","webpack://./src/style/header.scss","webpack://./src/style/loader.scss","webpack://./src/style/product.scss","webpack://./src/style/productCategories.scss","webpack://./src/style/productShowcase.scss","webpack://./src/style/footer.scss","webpack://./src/style/sustainabilityBanner.scss","webpack://./src/style/toast.scss"],"names":[],"mappings":"AAgBA;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AApK5C;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AClL5C;EAEQ,gBAAgB,EAAA;;AAGpB;EALJ;IAOY,eAAe,EAAA,EAClB;;ADMT;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AElL5C;EACI,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB,EAAA;EAL1B;IAQQ,gBAAgB,EAAA;IARxB;MAagB,cAAc;MACd,0BAA0B,EAAA;MAd1C;QAkBoB,cAAc;QACd,eAAe;QACf,WAAW;QACX,mBAAmB,EAAA;;AAOvC;EAEQ,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB,EAAA;;AAI3B;EACI,sBAAsB,EAAA;EAD1B;IAGQ,WAAW,EAAA;EAHnB;IASQ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB,EAAA;IAdxB;MAiBY,UAAU;MACV,wBAAwB;MACxB,iBAAiB,EAAA;IAnB7B;MAuBY,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,2BAA2B;MAC3B,kBAAkB;MAClB,SAAS;MACT,sBAAsB,EAAA;IA9BlC;MAmCgB,MAAM,EAAA;IAId;MAvCR;QAyCgB,UAAU;QACV,cAAc,EAAA;MA1C9B;QA8CgB,eAAe,EAAA,EAClB;;AFrEb;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AGlL5C;EACI,eAAe,EAAA;EADnB;IAIQ,aAAa;IACb,eAAe;IACf,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,MAAK,EAAA;EATb;IAaQ,aAAa;IACb,YACJ,EAAA;EAfJ;IAmBQ,eAAc;IACd,QAAO;IACP,YAAW;IACX,aAAa;IACb,4BAAoC;IACpC,UAAU;IACV,6CAAyC;IACzC,2BAA2B;IAC3B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB,EAAA;IA7B1B;MAgCY,aAAa,EAAA;MAhCzB;QAyCoB,eAAe;QACf,gBAAgB,EAAA;IA1CpC;MAgDY,aAAa,EAAA;IAhDzB;MAqDgB,aAAa,EAAA;IArD7B;MAyDgB,aAAa,EAAA;IAzD7B;MA6DgB,aAAa,EAAA;IA7D7B;MAmEgB,wBAAwB,EAAA;IAnExC;MAwEY,gBAAgB;MAChB,YAAY,EAAA;MAzExB;QA4EgB,mBAAmB;QACnB,eAAe;QACf,qBAAqB;QACrB,WAAW,EAAA;QA/E3B;UAkFoB,2BAA2B,EAAA;QAlF/C;UAuFwB,WAAW;UACX,gBAAgB;UAChB,eAAe,EAAA;QAzFvC;UA6FwB,gBAAgB;UAChB,eAAe,EAAA;IA9FvC;MAqGY,sBAAsB;MACtB,YAAY;MACZ,yBAAyB,EAAA;MAvGrC;QA2GoB,eAAe;QACf,kBAAkB,EAAA;MA5GtC;QAgHoB,gBAAgB,EAAA;MAhHpC;QAsHoB,eAAe;QACf,kBAAkB,EAAA;MAvHtC;QA6HgB,eAAe,EAAA;EA7H/B;IAmIQ,aAAa;IACb,eAAe;IACf,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,MAAM;IACN,gBAAgB,EAAA;IAzIxB;MA4IY,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,4CAA4C,EAAA;IA/IxD;MAmJY,cAAc,EAAA;EAItB;IAvJJ;MAyJY,sBAAsB,EAAA,EACzB;;AAKT;EAGY,cAAc,EAAA;;AAH1B;EAOY,mCAAmC,EAAA;;AHxJ/C;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AIlL5C;EACI,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAoC;EAGhC,kCAAkC;EAClC,4BAA4B;EAE5B,sBAAsB,EAAA;EAG1B;IAlBJ;MAmBQ,iBAAiB,EAAA,EAExB;;AJPD;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AKlL5C;EAIQ,cAAc;EACd,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAK3B;EACI,yBLfkB,EAAA;EKctB;IAIQ,mBAAmB;IACnB,iBAAiB,EAAA;;ALHzB;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AMlL5C;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB;EAChB,UAAU,EAAA;;AAGd;EACI,0BAA0B;EAC1B,8BAA8B,EAAA;;AAGlC;EACI,6CAAsC;EACtC,0BAA0B;EAC1B,2BAA2B,EAAA;;AAG/B;EAEI,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC,EAAA;;AAItC;EACI,6CAAsC,EAAA;;AAG1C;EACI,WAAW;EACX,iBAAiB;EACjB,mHAAmH;EACnH,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,eAAe;EACf,iBAAiB,EAAA;;AAGrB;EACI,mBAAmB;EACnB,WAAW,EAAA;;AAGf;EACI,UAAU;EACV,eAAe;EACf,aAAa,EAAA;;AAGjB;EACI,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc,EAAA;;AAGlB;EACI,aAAa;EACb,uBAAuB,EAAA;EAF3B;IAKQ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW,EAAA;IAbnB;MAgBY,sBAAsB;MACtB,WAAW,EAAA;;AAKvB;EAEQ,wCAAwC;EACxC,sBAAsB;EACtB,6BAA6B,EAAA;;AAJrC;EASY,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B,EAAA;EAdtC;IAiBgB,iCAAiC;IACjC,sBAAsB,EAAA;;AAlBtC;EAyBQ,kBAAkB;EAClB,WAAW,EAAA;EA1BnB;IA6BY,sBAAsB;IACtB,WAAW,EAAA;;ANhHvB;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AO1K5C;EACI,iBAAiB,EAAA;;AAGrB;EAEQ,gBAAgB,EAAA;;AAQxB;EAGQ,qDAAqD;EACrD,kDAAkD,EAAA;;AAJ1D;EAQQ,wBAAwB,EAAA;;AAIhC;EACI,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,uBAAuB,EAAA;EAN3B;IASQ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBPlDc;IOmDd,WAAW,EAAA;EAfnB;IAoBQ,kBAAkB,EAAA;EApB1B;IA4BQ,kBAAkB;IAClB,SAAS;IACT,gCAA+B;IAC/B,WAAW;IACX,QAAQ,EAAA;EAhChB;IAoCQ,kBAAkB;IAClB,SAAS;IACT,wCAAwC;IACxC,YAAY;IACZ,UAAU,EAAA;EAxClB;IA4CQ,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,aAAa,EAAA;IA/CrB;MAmDY,qBAAqB;MACrB,WAAW;MACX,kBAAkB;MAClB,eAAe,EAAA;MAtD3B;QAyDgB,0BAA0B,EAAA;EAzD1C;IA+DQ,kBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,kBAAkB,EAAA;IAnE1B;MAsEY,aAAa,EAAA;EAtEzB;IA2EQ,UAAU,EAAA;IA3ElB;MA+EgB,qBAAqB;MACrB,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,yBAAyB;MACzB,gCAAgC;MAChC,kBAAkB,EAAA;MArFlC;QAyFwB,8CAA8C;QAC9C,aAAa;QACb,WAAW;QACX,cAAc;QACd,WAAW;QACX,SAAS;QACT,kBAAkB;QAClB,gBAAgB;QAChB,iDAAiD;QACjD,QAAQ,EAAA;MAlGhC;QAsGwB,WAAW;QACX,OAAO,EAAA;EAvG/B;IA8GQ,kBAAkB,EAAA;IA9G1B;MAiHY,kBAAkB,EAAA;EAjH9B;IAsHQ,iBAAiB,EAAA;IAtHzB;MAyHY,kBAAkB,EAAA;EAM1B;IA/HJ;MAiIY,kBAAkB,EAAA;MAjI9B;QAsIgB,iBAAkB,EAAA,EACrB;EAvIb;IA4IQ,kBAAkB;IAClB,UAAU;IACV,6BAA6B,EAAA;IA9IrC;MAiJY,iBAAiB,EAAA;EAjJ7B;IAsJQ,kBAAkB;IAClB,SAAS;IACT,4BAA4B,EAAA;IAxJpC;MA2JY,qBAAoB,EAAA;EAM5B;IAjKJ;MAmKY,aAAa,EAAA;IAnKzB;MAuKY,aAAa,EAAA;IAvKzB;MA2KY,UAAU;MACV,wBAAwB,EAAA;IA5KpC;MAgLY,cAAc;MACd,kBAAkB;MAClB,YAAY;MACZ,UAAU,EAAA;IAnLtB;MAuLY,kBAAkB;MAClB,MAAM;MACN,sBAAsB;MACtB,aAAa;MACb,aAAa;MACb,oBAAoB,EAAA;IA5LhC;MAiMgB,gBAAgB,EAAA,EACnB;EAlMb;IAwMY,cAAc,EAAA;IAxM1B;MA0MgB,eAAe;MACf,yBAAyB;MACzB,cAAc;MAKd,qBAAqB,EAAA;MAjNrC;QA8MoB,WAAU;QACV,gCAAgC,EAAA;;AAQpD;EAvNA;IAyNQ,aAAa,EAAA;IAzNrB;MA2NY,aAAa,EAAA,EAChB;;AAIT;EAhOA;IAkOQ,YAAY,EAAA,EACf;;AAIL;EACI,kBAAkB,EAAA;EADtB;IAIQ,mCAAmC,EAAA;;AAS3C;EAEI,YAAY,EAAA;EAFhB;IAKQ,sDAAsD,EAAA;EAL9D;IASQ,UAAU,EAAA;EATlB;IAaQ,UAAU,EAAA;EAblB;IAiBQ,UAAU;IACV,oCAAoC,EAAA;EAlB5C;IAuBQ,YAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB,EAAA;IA1B1B;MA6BY,eAAe;MACf,kBAAkB,EAAA;EA9B9B;IAqCQ,SAAS;IACT,SAAS,EAAA;IAtCjB;MAyCY,6BAA6B,EAAA;EAzCzC;IA8CQ,UAAU;IACV,SAAS,EAAA;IA/CjB;MAkDY,6BAA6B,EAAA;;AAOzC;EACI,YAAY;EACZ,cAAc;EACd,yBPpVkB;EOqVlB,eAAe;EACf,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,aAAY,EAAA;EARhB;IAWQ,kBAAiB;IACjB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,kBAAkB,EAAA;IAf1B;MAkBY,aAAa,EAAA;EAlBzB;IAuBQ,iBAAiB,EAAA;EAvBzB;IA2BQ,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB,EAAA;IAvC3B;MA0CY,eAAe;MACf,eAAe;MACf,aAAa;MACb,oBAAoB;MACpB,WAAW,EAAA;MA9CvB;QAiDgB,sBAAsB;QACtB,WAAU;QACV,oBAAoB,EAAA;IAnDpC;MAwDY,UAAU;MACV,iBAAiB;MACjB,iBAAiB,EAAA;IA1D7B;MA8DY,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,gCAAgC;MAChC,UAAU;MACV,WAAW;MACX,YAAY,EAAA;IApExB;MAwEY,sBAAsB;MACtB,UAAU;MACV,YAAY;MACZ,uBAAuB;MACvB,mBAAmB,EAAA;IA5E/B;MAgFY,kBAAkB;MAClB,WAAW,EAAA;MAjFvB;QAoFgB,mBAAmB;QACnB,WAAW,EAAA;QArF3B;UAwFoB,qBAAqB;UACrB,WAAW;UACX,eAAe;UACf,2BAA2B;UAC3B,qBAAqB;UACrB,cAAc;UACd,kBAAkB;UAClB,2BAA2B,EAAA;UA/F/C;YAkGwB,0BAA0B,EAAA;MAlGlD;QAyGgB,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,iBAAiB,EAAA;EAQ7B;IApHJ;MAuHY,UAAU;MACV,wBAAwB,EAAA;IAxHpC;MA6HgB,gBAAgB,EAAA,EACnB;;AAKb;EAnIA;IAsIY,YAAY,EAAA,EACf;;AAKT;EAzbA;IA2bQ,aAAa,EAAA;EA9IrB;IAkJQ,aAAa;IACb,mBAAmB,EAAA;EA1d3B;IA8dQ,gBAAgB,EAAA,EACnB;;APzdL;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AQlL5C;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;EAZvB;IAeQ,UAAU,EAAA;EAflB;IAmBQ,gBAAe;IACf,aAAa,EAAA;EApBrB;IAwBQ,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB,EAAA;;ARd1B;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;ASlL5C;EAGQ,eAAe,EAAA;EAHvB;IAMY,qBAAqB;IACrB,sBAAsB,EAAA;;AAPlC;EAaQ,gBAAgB;EAChB,SAAS,EAAA;;AAdjB;EAmBQ,WAAW,EAAA;;AAnBnB;EAwBQ,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB,EAAA;;AA3B3B;EA+BQ,0BAA0B;EAC1B,gBAAgB,EAAA;;AAhCxB;EAqCQ,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EA9C3B;IAiDY,WAAW;IACX,iBAAiB;IACjB,2BAA2B,EAAA;EAnDvC;IAuDY,cAAc;IACd,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB,EAAA;EA5D5B;IAgEY,UAAU;IACV,sBAAsB,EAAA;EAjElC;IAqEY,mBAAmB;IACnB,6BAA6B,EAAA;;AAtEzC;EA4EY,eAAe,EAAA;EA5E3B;IA+EgB,wCAAwC;IACxC,eAAe,EAAA;;AAhF/B;EAsFQ,eAAe;EACf,eAAe;EACf,qBAAqB,EAAA;;AT1E7B;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AUlL5C;EAIQ,sBAAsB,EAAA;;AAJ9B;EAQQ,kBAAkB;EAClB,eAAe;EACf,gBAAgB,EAAA;EAVxB;IAgBY,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,SAAS;IACT,2BAA2B,EAAA;EArBvC;IAyBY,mBAAmB,EAAA;IAzB/B;MA4BgB,qBAAqB,EAAA;EA5BrC;IAiCY,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uEAAiF;IACjF,MAAM;IACN,kBAAkB,EAAA;IAtC9B;MAyCgB,uEAAiF,EAAA;;AAMjG;EACI;IACI,qCAAoC,EAAA;IADxC;MAIQ,4BAA4B,EAAA;IAJpC;MAQQ,0BAA0B;MAC1B,QAAQ,EAAA,EACX;;AV5CT;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AWlL5C;EAGQ,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,kCAAkC,EAAA;;AAR1C;EAaQ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB,EAAA;;AAG1B;EAnBJ;IAqBY,eAAe,EAAA;EArB3B;IAyBY,eAAe;IACf,yBAAyB;IACzB,mBAAmB,EAAA;EA3B/B;IA+BY,eAAe,EAAA,EAClB;;AAhCT;EAoCQ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB,EAAA;EAzC7B;IA4CY,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB,EAAA;IAnD5B;MAsDgB,kBAAkB;MAClB,WAAW;MACX,kCAAkC,EAAA;IAxDlD;MA4DgB,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,MAAM;MACN,8BAA8B,EAAA;MAhE9C;QAmEoB,UAAU,EAAA;IAnE9B;MAwEgB,UAAU;MACV,2DAA2D,EAAA;EAzE3E;IA+EgB,UAAU,EAAA;EA/E1B;IAoFgB,UAAU,EAAA;;AXtE1B;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AYlL5C;EACI,yBZHkB,EAAA;EYEtB;IAIQ,UAAU;IACV,YAAY;IACZ,cAAc;IACd,cAAc,EAAA;EAPtB;IAYQ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,yBAAyB,EAAA;IAhBjC;MAmBY,eAAe;MACf,mBAAmB,EAAA;IApB/B;MAwBY,qBAAqB;MACrB,WAAW;MACX,mBAAmB,EAAA;EA1B/B;IA+BQ,aAAa,EAAA;IA/BrB;MAmCY,YAAY;MACZ,mBZtCU;MYuCV,yBAAyB;MACzB,eAAe,EAAA;IAtC3B;MA0CY,uBAAuB;MACvB,yBAAyB,EAAA;EA3CrC;IAgDQ,aAAa;IACb,kBAAkB;IAClB,cAAc,EAAA;IAlDtB;MAqDY,kBAAkB;MAClB,kBAAkB;MAClB,YAAY,EAAA;IAvDxB;MA2DY,UAAU,EAAA;IA3DtB;MA+DY,iBAAiB,EAAA;IA/D7B;MAoEgB,UAAU,EAAA;IApE1B;MAwEgB,UAAU,EAAA;;AAM1B;EACI,sBAAsB;EACtB,YAAY,EAAA;EAFhB;IAKQ,YAAY;IACZ,uBAAuB,EAAA;EAN/B;IAUQ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAb3B;MAgBY,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,sBAAsB;MACtB,cAAc;MACd,iBAAiB;MACjB,kBAAkB,EAAA;MAtB9B;QAyBgB,WAAW;QACX,eAAe,EAAA;MA1B/B;QA8BgB,yBZ9GM;QY+GN,sBAAsB;QACtB,gCAAgC,EAAA;;AZhGhD;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AalL5C;EAEQ,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB,EAAA;EAPxB;IAUY,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4GAA4G;IAC5G,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB,EAAA;EAhB7B;IAoBY,sBAAsB;IACtB,UAAU;IACV,sBbvBI;IawBJ,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU,EAAA;IA7BtB;MAiCgB,4CAA4C;MAC5C,gBAAgB;MAChB,eAAe,EAAA;IAnC/B;MAwCgB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,mBAAmB,EAAA;EAI3B;IA/CR;MAiDgB,UAAU,EAAA,EACb;EAGL;IArDR;MAsDY,uBAAuB,EAAA;MAtDnC;QAyDgB,UAAU,EAAA;QAzD1B;UA4DoB,eAAe,EAAA;QA5DnC;UAgEoB,eAAe,EAAA,EAClB;EAIT;IArER;MAsEY,YAAY,EAAA;MAtExB;QAyEgB,WAAW,EAAA;QAzE3B;UA4EoB,eAAe,EAAA;QA5EnC;UAgFoB,eAAe;UACf,iBAAiB,EAAA,EACpB;;AbpEjB;EACI,qBAAqB;EACrB,+HAA+H,EAAA;;AAGnI;EACI,wBAAwB;EACxB,8GAA8G,EAAA;;AAGlH;EACI,oBAAoB;EACpB,gGAAgG,EAAA;;AAGpG;EACI,yBAAyB;EACzB,uHAAuH,EAAA;;AAG3H;EACI,mBAAmB,EAAA;;AAGvB;EACI,qCAtCkC;EAuClC,gBAAgB;EAChB,mBAAmB;EAEnB,kBAAkB,EAAA;;AAGtB;EACI,+BA3C8B,EAAA;;AA8ClC;EACI,2BA9CqB,EAAA;;AAiDzB;EACI,kCApDiC;EAqDjC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qCA9DkC;EA+DlC,gBAAgB;EAChB,sBAlEY;EAmEZ,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB,EAAA;EAZrB;IAeQ,yBAAyB;IACzB,kBAAkB,EAAA;EAhB1B;IAoBQ,sBAnFQ;IAoFR,sBAAsB;IACtB,8BAA8B,EAAA;EAtBtC;IA0BQ,sBAAsB;IACtB,sBAAsB,EAAA;EA3B9B;IA+BQ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB,EAAA;EAlC/B;IAsCQ,YAAY,EAAA;IAtCpB;MAyCY,6BAA6B;MAC7B,sBAzGI;MA0GJ,sBAAsB,EAAA;;AAKlC;EAGQ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB,EAAA;;AAI3B;EAEI,oBAAoB,EAAA;;AAGxB;EACI,cAAc,EAAA;;AAOlB;EACI,4BAA4B,EAAA;;AAOhC;EACI,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sBAAuB;EACvB,2BAA2B,EAAA;EAL/B;IASY,YAAY;IACZ,sBAAsB,EAAA;EAVlC;IAoBQ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAA;IAvB5B;MA2BY,sBAAsB;MACtB,iBAAiB;MACjB,YACJ,EAAA;IA9BR;MAiCY,uBAAuB;MACvB,YAAY;MACZ,iBAAiB;MACjB,eAAe;MACf,gCAAgC,EAAA;;AclL5C;EAGQ,sBAAsB;EACtB,gBAAgB;EAChB,8BdPc,EAAA;EcEtB;IAQY,sBAAsB,EAAA","sourcesContent":["$primaryColor: #f6cfd9;\r\n$darkColor: #000;\r\n\r\n$primaryFont: \"Old Standard TT\", serif;\r\n// $secondaryFont: \"Montserrat\", serif;\r\n$secondaryFont: 'Raleway', sans-serif;\r\n$signatureFont: 'Signature', serif;\r\n$heroFont: 'Didor', serif;\r\n\r\n// .old-standard-tt-regular {\r\n//   font-family: \"Old Standard TT\", serif;\r\n//   font-weight: 400;\r\n//   font-style: normal;\r\n// }\r\n\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: local, url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Roboto-Italic-VariableFont_wdth_wght.ttf?v=1755013677');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Signature';\r\n    src: local, url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Authentic_Signature.otf?v=1755240739');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Didor';\r\n    src: local, url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Didor.otf?v=1755581960');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Montserrat';\r\n    src: local, url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/Montserrat-VariableFont_wght.ttf?v=1759954059');\r\n}\r\n\r\n*:disabled{\r\n    cursor: not-allowed;\r\n}\r\n\r\n.primaryFont{\r\n    font-family: $primaryFont;\r\n    font-weight: 400;\r\n    letter-spacing: 1px;\r\n    // text-transform: uppercase;\r\n    font-style: normal;\r\n}\r\n\r\n.signatureFont{\r\n    font-family: $signatureFont;\r\n}\r\n\r\n.heroFont{\r\n    font-family: $heroFont;\r\n}\r\n\r\n.secondaryFont{\r\n    font-family: $secondaryFont;\r\n    font-weight: 400;\r\n    letter-spacing: 1px;\r\n    font-size: 12px;\r\n    line-height: 1.5;\r\n}\r\n\r\nbutton,a.button {\r\n    font-family: $primaryFont;\r\n    font-weight: 300;\r\n    border: 2px solid $darkColor;\r\n    background-color: transparent;\r\n    padding: 12px 25px;\r\n    text-transform: uppercase !important;\r\n    color: #000 !important;\r\n    text-decoration: none;\r\n    letter-spacing: 2px;\r\n    text-align: center;\r\n    font-size: 12px;\r\n    line-height: 12px;\r\n\r\n    &.noBorder{\r\n        border-color: transparent;\r\n        padding: 10px 10px;\r\n    }\r\n\r\n    &:hover{\r\n        background-color: $darkColor;\r\n        color: #fff !important;\r\n        transition: all 1s ease-in-out;\r\n    }\r\n\r\n    &.dark{\r\n        color: #fff !important;\r\n        background-color: #000;\r\n    }\r\n\r\n    &.light{\r\n        background-color: #fff;\r\n        color: #000 !important;\r\n        border-color: #000;\r\n        outline: #fff solid 5px;\r\n    }\r\n\r\n    &:disabled{\r\n        opacity: 0.4;\r\n\r\n        &:hover{\r\n            background-color: transparent;\r\n            border: 2px solid $darkColor;\r\n            color: #000 !important;\r\n        }\r\n    }\r\n}\r\n\r\n.capitaliseFirstLetter,.capitaliseFirstLetter p {\r\n    &::first-letter{\r\n        @extend .primaryFont;\r\n        line-height: 65px;\r\n        font-size: 65px;\r\n        float: left;\r\n        padding-right: 10px;\r\n    }\r\n}\r\n\r\nh2{\r\n    @extend .primaryFont;\r\n    text-transform: none;\r\n}\r\n\r\np{\r\n    line-height: 2;\r\n}\r\n\r\nh1,h3{\r\n    @extend .primaryFont;\r\n}\r\n\r\nh1{\r\n    padding-top: 30px !important;\r\n}\r\n\r\np,li{\r\n    @extend .secondaryFont;\r\n}\r\n\r\n.sdBlogCard{\r\n    color: #fff;\r\n    text-decoration: none;\r\n    height: 400px !important;\r\n    background-size : cover;\r\n    border-radius: 0 !important;\r\n\r\n    &:hover{\r\n         .card-body h2{\r\n            color: black;\r\n            background-color: #fff;\r\n        }\r\n    }\r\n\r\n    // &:hover{\r\n    //     opacity: 0.8;\r\n    //     color: #fff;\r\n    // }\r\n\r\n    .card-body{\r\n        border-radius: 0;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: end;\r\n        \r\n\r\n        h4{\r\n            background-color: pink;\r\n            padding: 5px 10px;\r\n            color: black\r\n        }\r\n\r\n        h2{\r\n            background-color: black;\r\n            color: white;\r\n            padding: 5px 10px;\r\n            font-size: 25px;\r\n            transition: all 0.5s ease-in-out;\r\n        }\r\n    }\r\n\r\n}","@import 'variables';\r\n\r\n#notFound{\r\n    h1.signatureFont{\r\n        font-size: 10rem;\r\n    }\r\n\r\n    @media screen and (max-width: 600px) {\r\n        h1.signatureFont{\r\n            font-size: 5rem;\r\n        }\r\n    }\r\n}\r\n","@import 'variables';\r\n\r\n#sdAboutUs {\r\n    min-height: 500px;\r\n    background-attachment: fixed;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n\r\n    .card{\r\n        border-radius: 0;\r\n\r\n        .card-body{\r\n            p{\r\n                @extend .secondaryFont;\r\n                line-height: 2;\r\n                font-size: 14px !important;\r\n\r\n                &::first-letter{\r\n                    @extend .primaryFont;\r\n                    line-height: 2;\r\n                    font-size: 65px;\r\n                    float: left;\r\n                    padding-right: 10px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n#sdMission{\r\n    p{\r\n        line-height: 24px;\r\n        font-size: 14px !important;\r\n        letter-spacing: 1px;\r\n    }\r\n}\r\n\r\n#sdFeatures{\r\n    background-color: #000;\r\n    h2,h5,p{\r\n        color: #fff;\r\n    }\r\n\r\n    // padding: 50px 0;\r\n\r\n    .col-md-3{\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        border: 2px solid #464646;\r\n        position: relative;\r\n        overflow: hidden;\r\n\r\n        img{\r\n            width: 30%;\r\n            margin: 20px 0 20px 20px;\r\n            filter: invert(1);\r\n        }\r\n\r\n        p{\r\n            padding: 20px;\r\n            position: absolute;\r\n            height: 100%;\r\n            width: 100%;\r\n            background-color: #000000cc;\r\n            transition: all 1s;\r\n            top: 100%;\r\n            vertical-align: middle;\r\n        }\r\n\r\n        &:hover{\r\n            p{\r\n                top: 0;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 768px) {\r\n            img {\r\n                width: 80%; \r\n                margin: 10px 0; // Adjust margin for better spacing\r\n            }\r\n\r\n            h5{\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdCartArea {\r\n    z-index: 999999;\r\n\r\n    #sdBackground{\r\n        display: none;\r\n        position: fixed;\r\n        height: 100vh;\r\n        width: 99.9vw;\r\n        background-color: #000000aa;\r\n        top:0;        \r\n    }\r\n\r\n    lottie-player{\r\n        height: 200px;\r\n        width: 200px\r\n    }\r\n\r\n\r\n    #sdCart{\r\n        position:fixed;\r\n        top:0px;\r\n        width:400px;\r\n        height: 100vh;\r\n        background-color: rgb(245, 245, 245);\r\n        right: 0px;\r\n        box-shadow: rgba(99,99,99,.2) 0 2px 8px 0;\r\n        transform: translateX(100%);\r\n        transition: transform 0.5s;\r\n        z-index: 9999999;\r\n        max-width: 99.99vw;\r\n    \r\n        #nonEmptyCart{\r\n            display: flex;\r\n\r\n            h3{\r\n                // box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);\r\n                // -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);\r\n                // -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);\r\n\r\n                .warningMessage{\r\n                    @extend .heroFont;\r\n                    font-size: 14px;\r\n                    font-weight: 700;\r\n                }\r\n            }\r\n        }\r\n    \r\n        #emptyCart{\r\n            display: none;\r\n        }\r\n    \r\n        &.empty{\r\n            #nonEmptyCart{\r\n                display: none;\r\n            }\r\n    \r\n            #emptyCart{\r\n                display: flex;\r\n            }\r\n\r\n            &.updating{\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        &.updating {\r\n            #emptyCart{\r\n                display: none !important;\r\n            }\r\n        }\r\n        \r\n        #sdCartItemArea{\r\n            overflow-y: auto;\r\n            flex-grow: 1;\r\n    \r\n            .cartItem{\r\n                margin-bottom: 10px;\r\n                padding: 10px 0;\r\n                text-decoration: none;\r\n                color: #000;\r\n\r\n                &:hover{\r\n                    background-color: lightgray;\r\n                }\r\n        \r\n                .col-9{\r\n                    h6::nth-of-type(1){\r\n                        color: gray;\r\n                        font-weight: 200;\r\n                        font-size: 12px;\r\n                    }\r\n\r\n                    h6::nth-of-type(2){\r\n                        font-weight: 200;\r\n                        font-size: 14px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        #sdDetailsBox{\r\n            background-color: #fff;\r\n            margin: 20px;\r\n            padding: 30px 30px 0 30px;\r\n\r\n            div{\r\n                p{\r\n                    font-size: 12px;\r\n                    margin-bottom: 8px;\r\n                }\r\n\r\n                & > p:nth-of-type(2){\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n\r\n            & div:nth-of-type(3){\r\n                p {\r\n                    font-size: 16px;\r\n                    font-style: normal;\r\n\r\n                }\r\n            }\r\n            \r\n            & > p{\r\n                font-size: 12px;\r\n            }\r\n        }\r\n    }\r\n\r\n    #loader{\r\n        display: none;\r\n        position: fixed;\r\n        height: 100vh;\r\n        width: 100vw;\r\n        background-color: #000000aa;\r\n        top: 0;\r\n        z-index: 9999999;\r\n\r\n        lottie-player{\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translateX(-50%) translateY(-50%);\r\n        }\r\n\r\n        &.show{\r\n            display: block;\r\n        }\r\n    }\r\n    \r\n    @media screen and (max-width: 420px){\r\n        #sdCart{\r\n            width: 100% !important;\r\n        }\r\n    }  \r\n}\r\n\r\n\r\n#sdCartArea{\r\n    &.show{\r\n        #sdBackground{\r\n            display: block;\r\n        }\r\n\r\n        #sdCart{\r\n            transform: translateX(0) !important;\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdCarousel {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: end;\r\n    align-items: center;\r\n    overflow: hidden;\r\n    position: relative;\r\n    aspect-ratio: 16/9;\r\n    background-color: rgb(219, 219, 219);\r\n\r\n    // img{\r\n        background-position: center center;\r\n        background-repeat: no-repeat;\r\n        \r\n        background-size: cover;\r\n    // }\r\n\r\n    @media (max-width: 870px) {\r\n        aspect-ratio: 1/1;    \r\n    }\r\n}","@import 'variables';\r\n\r\n.collectionTheIndianAffair{\r\n    \r\n    p::first-letter{\r\n        @extend .primaryFont;\r\n        line-height: 2;\r\n        font-size: 65px;\r\n        float: left;\r\n        padding-right: 10px;\r\n    }\r\n\r\n}\r\n\r\n.sdCategoryHeader {    \r\n    background-color: $primaryColor;\r\n\r\n    p{\r\n        letter-spacing: 1px;\r\n        line-height: 24px;\r\n    }\r\n}","@import 'variables';\r\n\r\n.modal .modal-content{\r\n    border-radius: 0;\r\n}\r\n\r\n.modal .modal-body{\r\n    border-radius: 0;\r\n    padding: 0;\r\n}\r\n\r\n.modal h5{\r\n    font-size: 21px !important;\r\n    margin-bottom: 30px !important;\r\n}\r\n\r\n.modal p{\r\n    font-family: $secondaryFont !important;\r\n    font-size: 14px !important;\r\n    font-weight: 300 !important;\r\n}\r\n\r\n.modal input{\r\n    @extend .secondaryFont;\r\n    border: solid 2px #000 !important;\r\n    border-radius: 0 !important;\r\n    font-size: 12px !important;\r\n    border-width: 0 0 2px 0 !important;\r\n    // font-style: italic;\r\n}\r\n\r\n.modal input ::placeholder{\r\n    font-family: $secondaryFont !important;\r\n}\r\n\r\n.modal #sdSideImage{\r\n    width: 100%;\r\n    aspect-ratio: 1/1;\r\n    background-image: url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/SD05-Bralette-Back.jpg?v=1764647409');\r\n    background-size: cover;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.modal #sdSideImage div{\r\n    width: 90%;\r\n    aspect-ratio: 1/1;\r\n    border: #000 2px solid;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.modal #sdSideImage img{\r\n    max-height: 90%;\r\n    filter: invert(1);\r\n}\r\n\r\n.modal .fields{\r\n    margin-bottom: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.modal .fields .validation{\r\n    color: red;\r\n    font-size: 12px;\r\n    display: none;\r\n}\r\n\r\n.modal .fields.is-invalid .validation{\r\n    margin-bottom: 0px;\r\n    line-height: 30px !important;\r\n    display: block;\r\n}\r\n\r\n.socialMedia{\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    a{\r\n        height: 50px;\r\n        width: 50px;\r\n        border-radius: 50%;\r\n        border: solid 2px #000;\r\n        margin: 0 10px 10px 10px;\r\n        line-height: 48px;\r\n        text-align: center;\r\n        font-size: 25px;\r\n        color: #000;\r\n\r\n        &:hover{\r\n            background-color: #000;\r\n            color: #fff;\r\n        }\r\n    }\r\n}\r\n\r\n#gateway_password{\r\n    input{\r\n        background-color: transparent !important;\r\n        color: #fff !important;\r\n        border-color: #fff !important;\r\n    }\r\n\r\n    .modal{\r\n        button{\r\n            background-color: #fff !important;\r\n            color: #000 !important;\r\n            border: none !important;\r\n            border-radius: 0 !important;\r\n            padding: 10px 20px !important;\r\n            font-size: 14px !important;\r\n\r\n            &:disabled{\r\n                background-color: gray !important;\r\n                color: #000 !important;\r\n            }\r\n        }\r\n    }\r\n    \r\n\r\n    .socialMedia a{\r\n        border-color: #fff;\r\n        color: #fff;\r\n\r\n        &:hover{\r\n            background-color: #fff;\r\n            color: #000;\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n// #sdStdSubHeader{\r\n//     background-color: #000;\r\n//     height: 40px;\r\n//     width: 99.99vw;\r\n    \r\n// }\r\n\r\n\r\n#sdPageContent{\r\n    margin-top: 150px;\r\n}\r\n\r\n.sdFixedHeader{\r\n    #sdPageContent{\r\n        margin-top: 90px;\r\n    }\r\n\r\n    #sdStdHeader{\r\n        @extend .StdHeaderCollapsedClass;\r\n    }\r\n}\r\n\r\nbody.landing {\r\n\r\n    #backgroundOverlay{\r\n        background-color: rgba(255, 255, 255, 0.8) !important;\r\n        clip-path: polygon(5% 5%, 95% 7%, 95% 95%, 5% 95%);\r\n    }\r\n    \r\n    #sdPageContent{\r\n        margin-top: 0 !important;\r\n    }\r\n}\r\n\r\n#sdStdHeader{\r\n    height: 150px;\r\n    width: 99.99vw;\r\n    position: fixed;\r\n    top: 0px;\r\n    z-index: 999;\r\n    transition: all 1s ease;\r\n\r\n    #backgroundOverlay{\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background-color: $primaryColor;\r\n        z-index: -1;\r\n        // clip-path: polygon(5% 5%, 95% 7%, 95% 95%, 5% 95%);\r\n    }\r\n\r\n    .sdLogo,.sdLogoCollapsed,.sdTopLeftMenu.sdBottomCenterLeftMenu,.sdBottomCenterRightMenu,.sdBottomCenterLeftMenu a,.sdBottomCenterRightMenu a{\r\n        transition: all 1s;\r\n    }\r\n    \r\n    &.sdCollapsed{\r\n        @extend .StdHeaderCollapsedClass;\r\n    }\r\n\r\n    .sdLogo{\r\n        position: absolute;\r\n        left: 50%;\r\n        transform: translate(-50%,-50%);\r\n        height: 80%;\r\n        top: 50%;\r\n    }\r\n\r\n    .sdLogoCollapsed{\r\n        position: absolute;\r\n        left: 50%;\r\n        transform: translateX(-50%) scale(0.001);\r\n        height: 100%;\r\n        opacity: 0;\r\n    }\r\n\r\n    .sdTopLeftMenu {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 20px;\r\n        padding: 10px;\r\n\r\n        a{\r\n            @extend .primaryFont;\r\n            text-decoration: none;\r\n            color: #000;\r\n            margin-right: 20px;\r\n            font-size: 12px;\r\n\r\n            &:hover {\r\n                text-decoration: underline;\r\n            }\r\n        }\r\n    }\r\n\r\n    #sdMenuArea{\r\n        position:absolute;\r\n        top: 50%;\r\n        right: 5%;\r\n        transform: translateY(-50%);\r\n        transition: all 1s;\r\n\r\n        #sdSidebarToggleSwitch{\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .sdBottomCenterLeftMenu,.sdBottomCenterRightMenu{\r\n        top: 103px;\r\n\r\n            a{\r\n                @extend .secondaryFont;\r\n                text-decoration: none;\r\n                color: #000;\r\n                margin-right: 20px;\r\n                font-size: 14px;\r\n                text-transform: uppercase;\r\n                text-decoration: none !important;\r\n                position: relative;\r\n\r\n                span{\r\n                    &:after {    \r\n                        background: none repeat scroll 0 0 transparent;\r\n                        bottom: -10px;\r\n                        content: \"\";\r\n                        display: block;\r\n                        height: 2px;\r\n                        left: 50%;\r\n                        position: absolute;\r\n                        background: #000;\r\n                        transition: width 0.3s ease 0s, left 0.3s ease 0s;\r\n                        width: 0;\r\n                    }\r\n\r\n                    &:hover:after { \r\n                        width: 100%; \r\n                        left: 0; \r\n                    }\r\n                }\r\n            }\r\n    }\r\n\r\n    .sdBottomCenterLeftMenu {\r\n        margin-right: 20px;\r\n\r\n        a{\r\n            margin: 0 0 0 20px;\r\n        }\r\n    }\r\n\r\n    .sdBottomCenterRightMenu {\r\n        margin-left: 20px;\r\n\r\n        a{\r\n            margin: 0 20px 0 0;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    @media(max-width: 1335px) {\r\n        .sdBottomCenterLeftMenu,.sdBottomCenterRightMenu{\r\n            position: relative;\r\n            // display: grid;\r\n            // grid-template-columns: repeat(2, 1fr);\r\n\r\n            a{\r\n                margin:  10px 20px;\r\n            }\r\n        }    \r\n    }\r\n\r\n    .sdBottomCenterLeftMenu {\r\n        position: absolute;\r\n        right: 50%;\r\n        transform: translateX(-100px);\r\n        \r\n        a{\r\n            text-align: right;\r\n        }\r\n    }\r\n\r\n    .sdBottomCenterRightMenu {\r\n        position: absolute;\r\n        left: 50%;\r\n        transform: translateX(100px);\r\n        \r\n        li{\r\n            display:inline-block;\r\n        }\r\n    }\r\n\r\n    /////////////////////////////Small Screen///////////////////////////////////////\r\n\r\n    @media(max-width: 1060px) {\r\n        .sdBottomCenterLeftMenu, .sdBottomCenterRightMenu {\r\n            display: none;\r\n        }\r\n\r\n        .sdLogo,.sdLogoM{\r\n            display: none;\r\n        }\r\n        \r\n        .sdLogoCollapsed{\r\n            left: 30px;\r\n            transform: translateX(0);\r\n        }\r\n\r\n        .sdLogoM{\r\n            display: block;\r\n            position: absolute;\r\n            height: 120%;\r\n            left: 30px;\r\n        }\r\n\r\n        .sdTopLeftMenu {\r\n            position: absolute;\r\n            top: 0;\r\n            right: 20px !important;\r\n            padding: 10px;\r\n            display: flex;\r\n            justify-content: end;\r\n        }\r\n\r\n        #sdMenuArea{\r\n            #sdSidebarToggleSwitch{\r\n                display: initial;\r\n            }\r\n        }\r\n    }\r\n\r\n    .sdMenu{\r\n        ul{\r\n            margin-left: 0;\r\n            li{\r\n                font-size: 12px;\r\n                text-transform: uppercase;\r\n                margin: 10px 0;\r\n                a{\r\n                    color:#000;\r\n                    text-decoration: none !important;\r\n                }\r\n                list-style-type: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 550px) {\r\n    #sdStdHeader{\r\n        height: 150px;\r\n        .sdTopLeftMenu{\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 470px) {\r\n    #sdStdHeader .sdLogoCollapsed{\r\n        height: 40px;\r\n    }\r\n}\r\n\r\n\r\nbody.showSideBar{\r\n    overflow-y: hidden;\r\n\r\n    #sdStdSideBar{\r\n        transform: translateX(0) !important;    \r\n    }\r\n}\r\n\r\n\r\n\r\n////////////////////////////////////////////////////////////////////\r\n/// Std Header Collapsed Class\r\n\r\n.StdHeaderCollapsedClass{\r\n    // clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\r\n    height: 90px;\r\n\r\n    #backgroundOverlay{\r\n        clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\r\n    }\r\n\r\n    .sdTopLeftMenu{\r\n        opacity: 0;\r\n    }\r\n\r\n    .sdLogo{\r\n        opacity: 0;;\r\n    }\r\n\r\n    .sdLogoCollapsed{\r\n        opacity: 1;\r\n        transform: translateX(-50%) scale(1);\r\n        // height: 31px;\r\n    }\r\n\r\n    .sdBottomCenterLeftMenu,.sdBottomCenterRightMenu{\r\n        right : unset;\r\n        left: unset;\r\n        transform: unset;\r\n        transition: all 1s;\r\n\r\n        a {\r\n            font-size: 14px;\r\n            transition: all 1s;\r\n        }\r\n    }\r\n\r\n    // .sd\r\n\r\n    .sdBottomCenterRightMenu{\r\n        left: 60%;\r\n        top: 35px;\r\n        \r\n        a{\r\n            margin: 0 0 0 10px !important;\r\n        }\r\n    }\r\n\r\n    .sdBottomCenterLeftMenu{\r\n        right: 60%;\r\n        top: 35px;\r\n\r\n        a{\r\n            margin: 0 10px 0 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n///////////////////////////////////////////////////////////////////////\r\n\r\n#sdStdHeaderSM{\r\n    height: 90px;\r\n    width: 99.99vw;\r\n    background-color: $primaryColor;\r\n    position: fixed;\r\n    top: 0px;\r\n    z-index: 9999;\r\n    transition: all 1s ease;\r\n    display:none;\r\n\r\n    #sdMenuArea{\r\n        position:absolute;\r\n        top: 50%;\r\n        right: 10px;\r\n        transform: translateY(-50%);\r\n        transition: all 1s;\r\n\r\n        #sdSidebarToggleSwitch{\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .sdLogoCollapsed{\r\n        margin-left: 20px;\r\n    }\r\n\r\n    #sdStdSideBar{\r\n        position: fixed;\r\n        top: 0;\r\n        left: 0;\r\n        width: 250px;\r\n        height: 100vh;\r\n        z-index: 999;\r\n        background-color: #202020;\r\n        transition: transform 0.3s ease-in-out;\r\n        transform: translateX(-100%);\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: start;\r\n        align-items: center;\r\n\r\n        #close{\r\n            cursor: pointer;\r\n            font-size: 24px;\r\n            display: flex;\r\n            justify-content: end;\r\n            width: 100%;\r\n\r\n            button{\r\n                background-color: #fff;\r\n                color:#000;\r\n                align-self: flex-end;\r\n            }\r\n        }\r\n\r\n        #sdLogoText{\r\n            width: 80%;\r\n            margin: 30px auto;\r\n            filter: invert(1)\r\n        }\r\n\r\n        #sdLogo{\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-50%, -50%);\r\n            width: 80%;\r\n            z-index: -1;\r\n            opacity: 0.2;\r\n        }\r\n\r\n        #diamond{\r\n            background-color: #fff;\r\n            width: 50%;\r\n            height: 10px;\r\n            transform: skew(-45deg);\r\n            margin-bottom: 30px;\r\n        }\r\n\r\n        #menuArea{\r\n            overflow-y: scroll;\r\n            width: 100%;\r\n\r\n            .menus{\r\n                margin-bottom: 30px;\r\n                width: 100%;\r\n                a{\r\n                    @extend .primaryFont;\r\n                    text-decoration: none;\r\n                    color: #fff;\r\n                    font-size: 12px;\r\n                    border: #ffffff6e solid 1px;\r\n                    border-width: 0.5px 0;\r\n                    display: block;\r\n                    padding: 10px 20px;\r\n                    font-weight: 300 !important;\r\n\r\n                    &:hover {\r\n                        text-decoration: underline;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .sdCopyright{\r\n                @extend .primaryFont;\r\n                color: #fff;\r\n                font-size: 10px;\r\n                text-align: center;\r\n                padding: 5px 10px;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    /////////////////////////////Small Screen///////////////////////////////////////\r\n\r\n    @media(max-width: 1060px) {\r\n        \r\n        .sdLogoCollapsed{\r\n            left: 30px;\r\n            transform: translateX(0);\r\n        }       \r\n\r\n        #sdMenuArea{\r\n            #sdSidebarToggleSwitch{\r\n                display: initial;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(max-width: 400px) {\r\n    #sdStdHeaderSM{\r\n        .sdLogoCollapsed{\r\n            height: 70px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@media(max-width: 1060px) {\r\n    #sdStdHeader{\r\n        display: none;\r\n    }\r\n\r\n    #sdStdHeaderSM{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    #sdPageContent{\r\n        margin-top: 90px;\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdLoader{\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 99.99vw;\r\n    height: 100vh;\r\n    background: #fff;\r\n    transition: opacity 1s ease-in-out;\r\n    z-index: 9999999999;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    &.sdHideLoader{\r\n        opacity: 0;\r\n    }\r\n\r\n    #sdLogoContainer{\r\n        max-height:70vh;\r\n        height: 300px;\r\n    }\r\n\r\n    #sdLoaderMessage{\r\n        font-family: 'Didor', serif;\r\n        font-size: 18px;\r\n        font-weight: 300;\r\n        margin-top: 20px;\r\n        text-align: center;\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdProduct {    \r\n    #sdBreadcrumbs {\r\n        @extend .primaryFont;\r\n        font-size: 12px;\r\n        \r\n        a{\r\n            text-decoration: none;\r\n            color: grey !important;\r\n        }\r\n    }\r\n\r\n    #sdProductViewer{\r\n        // height: calc(100vh - 90px);\r\n        position: sticky;\r\n        top: 90px;\r\n        // filter: grayscale(1);\r\n    }\r\n\r\n    #sdViewer img{\r\n        width: 100%;\r\n    }\r\n\r\n    .sdDescription{\r\n        @extend .primaryFont;\r\n        font-size: 16px;\r\n        text-transform: none !important;\r\n        line-height: 24px;\r\n        letter-spacing: 1px;\r\n    }\r\n\r\n    h6{\r\n        font-size: 12px !important;\r\n        margin-top: 30px;\r\n    }\r\n    \r\n    .sdVariant{\r\n        @extend .primaryFont;\r\n        height: 30px;\r\n        aspect-ratio: 1/1;\r\n        border: 1px gray solid;\r\n        margin: 5px;\r\n        line-height: 30px;\r\n        text-align: center;\r\n        position: relative;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .sdColorSwatch{\r\n            height: 80%;\r\n            aspect-ratio: 1/1;\r\n            border: 0.5px solid #efefef;\r\n        }\r\n\r\n        p{\r\n            padding: 0 5px;\r\n            line-height: 30px;\r\n            vertical-align: middle;\r\n            margin: 0;\r\n            font-size: 12px;\r\n            font-weight: 200;\r\n        }\r\n\r\n        &.selected{\r\n            opacity: 1;\r\n            border: 2px #000 solid;\r\n        }\r\n\r\n        &.unavailable{\r\n            cursor: not-allowed;\r\n            filter: blur(1px) saturate(0);\r\n        }\r\n    }\r\n\r\n    #sdAccordion{\r\n        .accordion-item{\r\n            border-width: 0;\r\n\r\n            .accordion-button{\r\n                background-color: transparent !important;\r\n                border-width: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    #sdSizeChart{\r\n        font-size: 12px;\r\n        border-width: 0;\r\n        display: inline-block;\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdProductCategories {    \r\n    // background-color: #000;\r\n\r\n    .col-6{\r\n        z-index: 99 !important;\r\n    }\r\n\r\n    .sdProductCategory{\r\n        position: relative;\r\n        cursor: pointer;\r\n        overflow: hidden;\r\n\r\n        \r\n\r\n        h2{\r\n            @extend .primaryFont;\r\n            position: absolute;\r\n            color: #fff;\r\n            z-index: 9;\r\n            bottom: 30px;\r\n            left: 50%;\r\n            transform: translateX(-50%);\r\n        }\r\n\r\n        img{\r\n            transform: scale(1);\r\n            \r\n            &:hover{\r\n                transform: scale(1.1);\r\n            }\r\n        }\r\n\r\n        div{\r\n            width: 100%;\r\n            height: 100%;\r\n            position: absolute;\r\n            background: linear-gradient(180deg,rgba(0, 63, 91, 0) 52%, rgba(0, 0, 0, 1) 100%);\r\n            top: 0;\r\n            transition: all 1s;\r\n\r\n            &:hover{\r\n                background: linear-gradient(180deg,rgba(0, 63, 91, 0) 25%, rgba(0, 0, 0, 1) 100%);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 870px) {\r\n    #sdProductCategories {\r\n        grid-template-columns: repeat(2,1fr);\r\n\r\n        .sdCategory{\r\n            aspect-ratio: 1/1 !important;\r\n        }\r\n\r\n        h5{\r\n            bottom: initial !important;\r\n            top: 50%;\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n.sdProductShowcase {\r\n    h6{\r\n        @extend .primaryFont;\r\n        text-transform: uppercase;\r\n        font-weight: 300;\r\n        letter-spacing: 1px;\r\n        color: #000 !important;\r\n        text-decoration: none !important;\r\n        text-decoration-color: transparent;\r\n    }\r\n\r\n    h4,h5{\r\n        @extend .secondaryFont;\r\n        font-size: 16px;\r\n        text-transform: uppercase;\r\n        letter-spacing: 1px;\r\n        color: #000 !important;\r\n    }\r\n\r\n    @media (max-width: 574px) {\r\n        h3{\r\n            font-size: 16px;    \r\n        }\r\n\r\n        h4{\r\n            font-size: 16px;\r\n            text-transform: uppercase;\r\n            letter-spacing: 1px;\r\n        }\r\n\r\n        h6{\r\n            font-size: 12px;\r\n        }\r\n    }\r\n\r\n    .col-md-3{\r\n        display: flex;\r\n        flex-direction: column; \r\n        align-items: center;\r\n        justify-content: center;\r\n        position: relative;\r\n        text-decoration: none;\r\n        \r\n        .sdProductImg{\r\n            width: 100%;\r\n            aspect-ratio: 1/1;\r\n            display: flex;\r\n            position: relative;\r\n            margin: 10px;\r\n            justify-content: center;\r\n            align-items: center;\r\n            overflow: hidden;\r\n\r\n            .sdLogoContainer{\r\n                position: absolute;\r\n                width: 100%;\r\n                transition: opacity 3s ease-in-out;\r\n            }\r\n\r\n            .sdFeaturedImage{\r\n                position: absolute;\r\n                width: 100%;\r\n                height: auto;\r\n                top: 0;\r\n                transition: all 1s ease-in-out;\r\n                \r\n                &:hover{\r\n                    opacity: 0;\r\n                }\r\n            }\r\n\r\n            .sdHoverImage{\r\n                opacity: 1;\r\n                transition: opacity 1s ease-in-out,transform 6s ease-in-out;\r\n            }\r\n        }\r\n\r\n        &:hover{\r\n            .sdHoverImage{\r\n                opacity: 1;\r\n                // transform: scale(2);\r\n            }\r\n            \r\n            .sdFeaturedImage :not(.sdOnlyOne){\r\n                opacity: 0;\r\n            }\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdFooter{\r\n    background-color: $primaryColor;\r\n\r\n    #sdLogoFooter{\r\n        width: 50%;\r\n        height: auto;\r\n        display: block;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .menuLinks{\r\n        @extend .secondaryFont;\r\n        display: flex;\r\n        flex-direction: column;\r\n        margin-bottom: 30px;\r\n        font-size: 13px;\r\n        text-transform: uppercase;\r\n\r\n        h6{\r\n            font-size: 18px;\r\n            margin-bottom: 30px;\r\n        }\r\n        \r\n        a{\r\n            text-decoration: none;\r\n            color: #000;\r\n            margin-bottom: 20px;\r\n        }\r\n    }\r\n\r\n    #sdMailingList{\r\n        display: flex;\r\n\r\n        input{\r\n            @extend .primaryFont;\r\n            height: 43px;\r\n            background: $primaryColor;\r\n            border-width: 0 0 0.8px 0;\r\n            font-size: 12px;\r\n        }\r\n\r\n        button{\r\n            border-width: 0 0 2px 0;\r\n            text-transform: uppercase;\r\n        }\r\n    }\r\n\r\n    #sdGotsCertification{\r\n        height: 100px;\r\n        position: relative;\r\n        display: block;\r\n\r\n        img{\r\n            position: absolute;\r\n            transition: all 1s;\r\n            height: 100%;\r\n        }\r\n        \r\n        img:nth-of-type(1){\r\n            opacity: 0;\r\n        }\r\n\r\n        img:nth-of-type(2){\r\n            filter: invert(1);\r\n        }\r\n        \r\n        &:hover{\r\n            img:nth-of-type(1){\r\n                opacity: 1;\r\n            }\r\n\r\n            img:nth-of-type(2){\r\n                opacity: 0;\r\n            }\r\n        }\r\n    }   \r\n}\r\n\r\n#sdSubFooter{\r\n    background-color: #000;\r\n    height: 80px;\r\n\r\n    .row,.container{\r\n        height: 100%;\r\n        justify-content: center;\r\n    }    \r\n\r\n    .col-12{\r\n        height: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .sdSocialMediaIcon{\r\n            height: 50px;\r\n            width: 50px;\r\n            border-radius: 50%;\r\n            border: solid 2px #fff;\r\n            margin: 0 10px;\r\n            line-height: 46px;\r\n            text-align: center;\r\n\r\n            i{\r\n                color: #fff;\r\n                font-size: 20px;\r\n            }\r\n\r\n            &:hover{\r\n                background-color: $primaryColor;\r\n                color: #000 !important;\r\n                transition: all 0.3s ease-in-out;\r\n            }\r\n        }\r\n\r\n        \r\n    }\r\n}","@import 'variables';\r\n\r\n#sdSustainabilityBanner {    \r\n    #banner{\r\n        background-color: azure;\r\n        width: 100%;\r\n        display: flex;\r\n        margin: 30px 0;\r\n        position: relative;\r\n        overflow: hidden;\r\n\r\n        #bannerImage{\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 100%;\r\n            background-image: url('https://cdn.shopify.com/s/files/1/0668/7670/2789/files/sustainable.jpg?v=1755535077');\r\n            background-size: cover;\r\n            background-position: center;\r\n            filter: blur(3px);\r\n        }\r\n\r\n        #box{\r\n            background-color: #fff;\r\n            width: 35%;\r\n            border: 2px solid $darkColor;\r\n            outline: 20px solid #fff;\r\n            margin: 70px;\r\n            padding: 20px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            align-items: start;\r\n            z-index: 9;\r\n            \r\n\r\n            h2{\r\n                font-family: 'Times New Roman', Times, serif;\r\n                text-align: left;\r\n                font-size: 50px;\r\n            }\r\n            \r\n            p{\r\n                @extend .secondaryFont;\r\n                font-size: 16px;\r\n                text-align: left;\r\n                line-height: 35px;\r\n                letter-spacing: 1px;\r\n            }\r\n        }\r\n\r\n        @media screen and (max-width: 1180px) {\r\n            #box{\r\n                width: 50%;\r\n            }\r\n        }\r\n\r\n        @media screen and (max-width: 991px) {\r\n            justify-content: center;\r\n            \r\n            #box{\r\n                width: 90%;\r\n\r\n                h2{\r\n                    font-size: 30px;\r\n                }\r\n\r\n                p{\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n\r\n        @media screen and (max-width: 420px) {\r\n            margin: 10px;\r\n\r\n            #box{\r\n                width: 100%;\r\n\r\n                h2{\r\n                    font-size: 30px;\r\n                }\r\n\r\n                p{\r\n                    font-size: 12px;\r\n                    line-height: 16px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@import 'variables';\r\n\r\n#sdToast {\r\n\r\n    #liveToast{\r\n        background-color: #000;\r\n        border-radius: 0;\r\n        border-left: 8px solid $primaryColor;\r\n\r\n        h5,p{\r\n            color: #fff !important;\r\n        }\r\n    }\r\n    \r\n\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
